import ActionBar from '../../../../components/ActionBar/NewActionBar';
import Button from '../../../../components/Button/Button';
import Constants from 'expo-constants';
import Images from '../../../../state/stores/Image/images';
import Loading from '../../../../components/Loading/Loading';
import SecondaryButton from '../../../../components/Button/SecondaryButton';
import Show from '../../../../components/Show/Show';
import StaticFrame from '../../../../components/Frames/StaticFrame/StaticFrame';
import styled from 'styled-components/native';
import { COLORS } from '../../../../config/designSystem/Colors';
import { FC, useState } from 'react';
import { Image } from 'react-native';
import { InstantHelpStackParamList } from '../../../../types/navigation';
import { StatusBar } from 'expo-status-bar';
import { View } from 'react-native-animatable';
import { assistanceKey, branchingKey, sessionStackKey, videocallKey } from '../../../../constants/routeKeys';
import { concatPath } from '../../../../utils/links/concatPath';
import { isWeb } from '../../../../config/designSystem/Layout';
import { logAmplitude } from '../../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { queryUpdateWpoRequest } from '../../../../state/queries/InstantHelp';
import { router, useGlobalSearchParams } from 'expo-router';
import { useOnMount } from '../../../../hooks/useOnMount';
import { useStores } from '../../../../hooks/useStores';


const Frame = styled.View`
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${isWeb ? 0 : Constants.statusBarHeight}px;
  margin-bottom: ${isWeb ? 0 : 32}px;
  margin-horizontal: 16px;
  background-color: '${COLORS.surface.primary}';
  opacity: 1;
`;
const titles: Record<InstantHelpStackParamList['TryAgain']['reason'], string> = {
  cannotCreateNewCallYet: 'CANNOT_CREATE_NEW_CALL_TITLE',
  counsellorGone: 'COUNSELLOR_GONE_TITLE',
  counsellorTimeout: 'COUNSELLOR_TIMEOUT_TITLE',
  errorInWPOApi: 'ERROR_IN_WPO_API_TITLE',
};
const secondaryTitles: Record<InstantHelpStackParamList['TryAgain']['reason'], string> = {
  cannotCreateNewCallYet: 'CANNOT_CREATE_NEW_CALL_SECONDARY',
  counsellorGone: 'COUNSELLOR_GONE_SECONDARY',
  counsellorTimeout: 'COUNSELLOR_TIMEOUT_SECONDARY',
  errorInWPOApi: 'ERROR_IN_WPO_API_SECONDARY',
};

type TryAgainProps = InstantHelpStackParamList['TryAgain']

const TryAgain: FC<TryAgainProps> = observer(() => {
  const params = useGlobalSearchParams();
  const {
    reason,
    activeCallId,
  } = params;
  // TODO sentry capture these unhappy cases
  const rootStore = useStores();
  const { language: languageStore, user } = rootStore;

  const region: string = user.user?.region || 'BE';
  const language: string | undefined | null= languageStore?.languageWPO || 'fr';
  const [loading, setLoading] = useState(false);

  const labels = languageStore.translate.MOBILE.ASSISTANCE;
  const callLabels = labels?.CALL;

  useOnMount(() => {
    logAmplitude('Instant Help Try Again Shown', {
      reason,
      activeCallId,
      region,
      language,
    });
  });

  // the instant-help questions play as a block inside their own session:
  // branching only understands a sessionId
  const goToInstantHelpSurvey = async () => {
    const sessionId = await rootStore.session.fetchSessionIdOfType('instantHelp');
    if (!sessionId) {
      console.warn('No session of type instantHelp');
      return;
    }
    router.navigate({
      pathname: concatPath([sessionStackKey, branchingKey],2) as string,
      params :{
        sessionId,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
      }
    });
  };
  const cancelCall = async () => {
    if (activeCallId && region && language) {
      await queryUpdateWpoRequest(
        Number(activeCallId),
        'ANY',
        'VIDEO',
      ).catch(console.error);

    }
  };

  const cancelCallAndTryAgain = async() => {
    setLoading(true);
    await cancelCall();
    setLoading(false);
    goToInstantHelpVideo();

  };
  const goToInstantHelpVideo = () => {
    router.navigate({
      pathname: concatPath([videocallKey], 0) as string,
      params: {
        timeStamp: Number(new Date())
      }
    });
  };

  const goToAssistance = () => {
    router.navigate(concatPath([assistanceKey]) as string);
  };

  if(loading) {
    return(<Loading />);
  }

  return (
    <Frame>
      <StatusBar style="dark" />
      <ActionBar
        width='100%'
        height={40}
        title={labels?.INSTANT_HELP?.TITLE}
        onExit={goToAssistance}
        onPrevious={() => { goToInstantHelpSurvey().catch(console.error); }}
      />
      <StaticFrame
        staticFrame={{
          mainTitle: callLabels[titles[reason]],
          secondaryTitle: callLabels[secondaryTitles[reason]],
        }}
        renderImage={props => (
          <Image
            source={Images.assistance.assistance_therapy}
            {...props}
          />
        )}
      />
      <View style={{width: '100%', position:'absolute', bottom: 0, alignItems:'center', justifyContent:'center'}}>
        <Show when={activeCallId && region && language}>
          <SecondaryButton
            onPress={cancelCallAndTryAgain}
            label={labels?.CALL?.BUTTON_CANCEL}
          />
        </Show>
        <Button
          onPress={() => { goToInstantHelpSurvey().catch(console.error); }}
          label={labels?.CALL?.BUTTON_TRY_PHONE}
        />
        <Button
          onPress={goToInstantHelpVideo}
          label={labels?.CALL?.BUTTON_RETRY}
        />
      </View>
    </Frame>
  );
});
export default TryAgain;
